var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "71px",
    viewBox: "0 0 65.0 71.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680,0 L1680,1080 L0,1080 L0,0 L1680,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i1",
    x: "-54.4881338%",
    y: "-49.1941656%",
    filterUnits: "userSpaceOnUse",
    width: "172.818986%",
    height: "165.758101%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    stdDeviation: 5,
    dx: 0,
    dy: 0,
    floodColor: "rgba(2, 255, 225, 0.304128)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,0 L35,41 L0,41 L0,0 L35,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2622667,0 C22.9387146,0 24.2995959,1.35453271 24.2995959,3.02422897 L24.300077,23.3944276 L34.9312103,40.829007 L9.11246873,40.829007 L10.0343467,39.3168925 L3.03732923,39.3168925 C1.36088128,39.3168925 0,37.9637967 0,36.2926636 L0,3.02422897 C0,1.35501168 1.36040023,0 3.03732923,0 Z M22.0208774,22.5724159 L11.8101789,39.3172757 L32.2315759,39.3172757 L22.0208774,22.5724159 Z M14.6449875,31.7563201 L1.51818357,31.7563201 L1.51818357,36.2930467 C1.51818357,37.1259981 2.19990379,37.8051612 3.03684818,37.8051612 L10.9558976,37.8051612 L11.9082163,36.2443544 C11.1881855,36.1249946 10.6308447,35.5304084 10.6308447,34.7805203 C10.6308447,33.9457009 11.3095536,33.2684058 12.1495093,33.2684058 C12.6478642,33.2684058 13.066904,33.5209869 13.3450067,33.8899486 L14.6449875,31.7563201 Z M22.7804503,7.56095561 L1.51818357,7.56095561 L1.51775063,30.2439182 L15.5662401,30.2439182 L22.0209255,19.6586379 L22.7804503,20.9051145 L22.7804503,7.56095561 Z M21.2617856,1.51211449 L3.03684818,1.51211449 C2.20028863,1.51211449 1.51818357,2.19089439 1.51818357,3.02422897 L1.51818357,6.04845794 L22.7804503,6.04845794 L22.7804503,3.02422897 C22.7804503,2.19127757 22.09873,1.51211449 21.2617856,1.51211449 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51866461,0 L1.51866461,1.51211449 L0,1.51211449 L0,0 L1.51866461,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0751395,0 L6.0751395,1.51211449 L0,1.51211449 L0,0 L6.0751395,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51866461,0 L1.51866461,7.56143458 L0,7.56143458 L0,0 L1.51866461,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51866461,0 L1.51866461,1.51211449 L0,1.51211449 L0,0 L1.51866461,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-317.0 -848.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(332.0 863.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.06927073311526755 0.075677570093454)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 34.9307293,0 34.9307293,40.829007 0,40.829007 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.662112757360016 3.099906542056076)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.51866461,0 1.51866461,1.51211449 0,1.51211449 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.69944198576102 3.099906542056076)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 6.0751395,0 6.0751395,1.51211449 0,1.51211449 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.33105637868001 27.29431308411217)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.51866461,0 1.51866461,7.56143458 0,7.56143458 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.33153742543776 36.36834112149532)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.51866461,0 1.51866461,1.51211449 0,1.51211449 0,0",
    stroke: "none",
    fill: "#55BAB0"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileType);
export default __webpack_public_path__ + "static/media/mobile-type.f50b5ec81620c3e5eab223f40b503f70.svg";
export { ForwardRef as ReactComponent };